import React, { Fragment, useState } from "react";
import QurealSection from "../common/QurealSection";
import ChatWithDesigner from "./ChatWithDesigner";
import InitialScreen from "./InitialScreen";
import { useAtom, useAtomValue } from "jotai";
import { messageListAtom } from "./atoms";
import styles from "./styles/AIHome.module.css";
import FeatureRequestBox from "../feedback/FeatureRequestBox";
import { Button } from "antd";
import { useMedia } from "react-use";
import { useItemsFine } from "../_actions/app/items";
import log from "cslog";

function AIHome({ me }) {
    const isMobile = useMedia("(max-width: 800px)");
    const message_list = useAtomValue(messageListAtom);
    const [collapsed, setCollapsed] = useState(true);
    const {
        isSuccess,
        isLoading,
        data: rs,
    } = useItemsFine("qdb_root_settings", "", true);

    const TOPBAR_HEIGHT = 50;
    const marginTop = 0;

    return (
        <div
            className={styles.wrapper}
            style={{
                gridTemplateColumns: collapsed ? "0 1fr" : "200px 1fr",
                // gridTemplateColumns: "0 1fr",
            }}
        >
            <div
                style={{
                    height: "100%",
                    backgroundColor: "aliceblue",
                }}
            >
                {/* <div>sidebar</div> */}
            </div>
            <div
                style={{
                    marginTop: 0,
                    // marginLeft: isMobile ? 0 : marginLeft,
                    overflow: isMobile ? "hidden" : "auto",
                    backgroundColor: "#F5F5F5",
                    maxHeight: `calc(100vh - ${TOPBAR_HEIGHT}px)`,
                    // maxHeight: "90vh", //for topbar
                }}
            >
                <QurealSection
                    footer={false}
                    wrapper_style={isMobile ? { padding: 0 } : {}}
                >
                    {message_list.length === 0 && (
                        <InitialScreen me={me} rs={rs} />
                    )}

                    {message_list.length > 0 && (
                        <ChatWithDesigner me={me} isMobile={isMobile} />
                    )}
                </QurealSection>
            </div>
        </div>
    );
}

export default AIHome;
